var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',[_c('div',{staticClass:"td-box"},[_c('span',{staticClass:"td-text ellipsis",attrs:{"data-original-title":""}},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }